import { render } from "./ObjManage.vue?vue&type=template&id=5ecaba08"
import script from "./ObjManage.vue?vue&type=script&lang=js"
export * from "./ObjManage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__